export default __webpack_public_path__ + "static/media/proceed_cart.36db59ee.svg";